import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import editUserServices from '../../services/edit-users/edit-users.service';
import ReferralsSearch from './referrals-search';
import ReferralsDataTable from './referrals-datatable';
import { OtherUserModel } from '../../models/all-user/edit-user-model';
import AppLoading from '../app-loading/app-loading';

const ReferralsRestrictionDashboard: React.FC = () => {
    
    const { t } = useTranslation();
    const [userList, setUserList] = useState<OtherUserModel[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Maybe don't load all users initially, only when search is clicked
    }, []);

    function handleSearch(query: string): void {
        setLoading(true);
        editUserServices.getUsers(query).then((response: any) => {
            const sortedData = [...response].sort((a, b) => b.userID - a.userID);
            setUserList(sortedData);
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    return (
        <>
        <style>{`
            .complaint-header-card {
                background: linear-gradient(135deg, #f8fffe 0%, #e8f5e9 100%);
                border-radius: 16px;
                padding: 1.5rem 2rem;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                border: 1px solid rgba(76, 175, 80, 0.1);
                margin-bottom: 1.5rem;
            }

            .complaint-title-wrapper {
                display: flex;
                align-items: center;
                gap: 0.75rem;
            }

            .complaint-icon-wrapper {
                width: 48px;
                height: 48px;
                background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
            }

            .complaint-icon-wrapper i {
                color: white;
                font-size: 1.5rem;
            }

            @media screen and (max-width: 768px) {
                .complaint-header-card .flex {
                    flex-direction: column;
                    align-items: flex-start !important;
                    gap: 1rem;
                }
            }
        `}</style>
        <div className="layout-content mt-3 mb-3">
            <div className="complaint-header-card">
                <div className="flex align-items-center justify-content-between">
                    <div>
                        <div className="complaint-title-wrapper">
                            <div className="complaint-icon-wrapper">
                                <i className="pi pi-users"></i>
                            </div>
                            <div>
                                <h1 className="text-800 font-bold text-3xl m-0" style={{ color: "#10492a" }}>
                                    Awareness Reward Control
                                </h1>
                                <p className="text-600 m-0 text-sm mt-1">
                                    Manage Referrals and Reward Earning Restrictions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ReferralsSearch onSearch={handleSearch} setLoading={setLoading} /> 
            
            <div className="mt-4">
               {userList.length > 0 ? (
                 <ReferralsDataTable data={userList}/>
               ) : (
                 <div className="surface-card p-4 shadow-2 border-round text-center text-700">
                   Please use the search above to find customers and view their details.
                 </div>
               )}
            </div>
        </div>
        {loading && <AppLoading />}
        </>
    );
}

export default ReferralsRestrictionDashboard;
